import { AuditService } from "./audit.service";
import { AuditoriaResolver } from "./resolvers/_auditoria-resolvers";

export const AuditoriaServices = [
  AuditoriaResolver,
  AuditService
]
